import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

import { AuditTrailTableStyles } from '../styles/AuditTrailTableStyles'

interface AuditTrailTableFooterProps {
  total: string
}

export const AuditTrailTableFooter = ({ total }: AuditTrailTableFooterProps) => {
  const { t } = useTranslation()
  const { footerRow, footerText } = AuditTrailTableStyles

  return (
    <View style={footerRow} wrap={false}>
      <Text style={footerText}>{t('audit_trail.table.footer.total')}</Text>
      <Text style={footerText}>{total}</Text>
    </View>
  )
}
